module.exports = __webpack_public_path__ + "img/foodworks-portal.f1b7830f.png";